import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const PurchaseInvoice = () => {
  return (
    <PrintPreferenceTabs type="purchase_invoice"></PrintPreferenceTabs>
  );
};
export default PurchaseInvoice;

